import Env from 'env';


export class ThemeInstance {

    // 
    muiSpacing = 8;


    // Page Layout
    pageMinWidth = Env.isDesktop ? 768 : 320;
    pageMinHeight = Env.isDesktop ? 768 : 480;

    pageMenuWidth = 140;
    pageContentsWidth = 960 - this.pageMenuWidth * 2;

    pageHeaderHeight = Env.isMobile ? 60 : 120;
    
    pageFooterHeight = 32;
    pageFooterFontSize = 12;

    pageHorzMargin = Env.isDesktop ? this.muiSpacing * 2 : 0;
    pageTopMargin = 10;
    pageBottomMargin = 0;

    pageContentsHorzMargin = Env.isDesktop ? 20 : 0;
    pageContentsTopMargin = Env.isDesktop ? 20 : 0;
    pageContentsBottomMargin = Env.isDesktop ? 20 : 0;

    projIconSize = 64;

    
    // constructor(scanTheme: ScanThemeInstance) {
    //     this.scan = scanTheme;
    // }
    //..= new ScanThemeInstance(this);


    //
    // Return CSS objects
    //
    cssButtonShadow() {
        return {
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        }
    }

    cssButtonHover() {
        return {
            "&:hover": {
                border: "2px solid #25afce66",
            }
        }
    }


};
